import {
  Datagrid,
  DateField,
  List,

  TextField,
  TextInput, required,
  ReferenceInput,
  SelectInput,
  ReferenceField,
  SimpleForm,
  Edit,
  Create,
  ArrayInput,
  AutocompleteInput,
  SimpleFormIterator,
  RecordContextProvider,
  SingleFieldList,
  ChipField,
  ArrayField,

  BooleanInput,

  FilterForm,
  usePermissions,
  NumberField,
  useGetList,
  CreateButton,
  TopToolbar,
  Title,
  Show,
  useCreate,
  useCreateSuggestionContext,
  AutocompleteArrayInput,
  ReferenceArrayInput,
  ReferenceArrayField,

  useRecordContext,
  SelectField,
  useNotify,

  NumberInput,
  Filter,
  ReferenceManyField,


} from "react-admin";


import useDetectKeyboardOpen from "use-detect-keyboard-open";

import {
  Box,

  Button,
  Typography,
  Dialog,
  Tab, Tabs,
  DialogActions,

  DialogContent,
  TextField as TextFieldMui,
  Grid,
} from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';

import {
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Divider,
} from '@material-ui/core';

import { isMobile, useMobileOrientation } from 'react-device-detect';
import {
  EditableDatagrid,
  RowForm,
} from "@react-admin/ra-editable-datagrid";

import React, { useState, useEffect } from 'react';
import keyBy from 'lodash/keyBy'
import {  Loading, ListContextProvider } from 'react-admin'
import { Link } from 'react-router-dom';

import { Card } from '@mui/material';

import {  CustomerCreateCommentButton } from './CustomerCreateButton';
import VerifiedIcon from '@mui/icons-material/Verified';
import WarningIcon from '@mui/icons-material/Warning';
import { ROLES, SERVER } from "../../../constants";
import { ColoredChipField, postRowClick } from "../../needs/Needs";
import { Add } from "@material-ui/icons";
import { choicesTime } from "../reminder/Reminder";

import { getAnalytics, logEvent } from "firebase/analytics";
import { DatagridUsersProps } from "../clue/Clue";
import { CreateFormActions } from "../../../components/FormActions";
import { HttpClient } from "../../../utils/requests";

import { IdateInput } from "../../../data/IdateTimeInput";

const FilterCustomer = (props) => {

  return (
    <Filter {...props}>
      <ReferenceInput variant="outlined" source="customerCategoryId" reference="customerCategory" >
        <SelectInput optionText="title" />
      </ReferenceInput>


      <ReferenceInput variant="outlined" source="customerRatingId" reference="customerRating" >
        <SelectInput optionText="title" />
      </ReferenceInput>

      {/* <AutocompleteInput optionText="refNum" alwaysOn/> */}
      <TextInput label=" جستجو" source="name" variant="outlined" alwaysOn />
      {/* <SearchInput variant="outlined" resettable source="q" alwaysOn /> */}
    </Filter>
  )
};

export const CustomerList = (props) => {
  const analytics = getAnalytics();
  logEvent(analytics, 'customer_list');

  return (
    //رتبه مشتری
    <List {...props} perPage={50} sort={{ field: 'order', order: 'ASC' }} filters={<FilterCustomer />}

    >
      {isMobile ? (
        <Datagrid rowClick="show" size="small" {...DatagridUsersProps}>
          <TextField source="order" width="20%" />
          <TextFieldApproved source="name" />
          {/* <TextField source="customerRefId" /> */}
          <ArrayField source="connectors" width="20%">
            <SingleFieldList>
              <ReferenceField link="show" allowEmpty={true} label="" source="objectId" reference="contact">
                <ApprovedChipField source="name" />
              </ReferenceField>
            </SingleFieldList>
          </ArrayField>
        </Datagrid>
      ) : (
        <Datagrid rowClick="show" size="small" {...DatagridUsersProps}>
          <TextField source="order" width="20%" />
          <TextFieldApproved source="name" />
          {/* <TextField source="customerRefId" /> */}
          <ArrayField source="connectors" width="20%">
            <SingleFieldList>
              <ReferenceField link="show" allowEmpty={true} label="" source="objectId" reference="contact">
                <ApprovedChipField source="name" />
              </ReferenceField>
            </SingleFieldList>
          </ArrayField>
          <ReferenceArrayField label="همکاران" source="users" reference="adminUsers" >
            <SingleFieldList linkType="show">
              <ChipField source="name" />
            </SingleFieldList>
          </ReferenceArrayField>

          {/* 
    <ArrayField source="companies" width="20%">
      <SingleFieldList>
        <ReferenceField link="show" allowEmpty={true} label="" source="objectId" reference="customer">
          <ApprovedChipField source="name" />
        </ReferenceField>
      </SingleFieldList>
    </ArrayField> */}
          <ReferenceField link={null} source="customerRatingId" reference="customerRating">
            <ChipField source="title" />
          </ReferenceField>


          {/* <ShowButton /> */}
        </Datagrid>
      )}
    </List>
  )
};
const ApprovedChipField = props => {

  return (
    <>
      <ChipField
        source={props.record[props.source]}
        icon={props.record.approved ? <VerifiedIcon fontSize="small" color="#0e79f3" /> : <WarningIcon fontSize="small" color="error" />}
        {...props}
      />
      {/* {props.record.approved ? <VerifiedIcon fontSize="small" color="success" /> : <WarningIcon  fontSize="small" color="error" />} */}


    </>

  );
};

const TextFieldApproved = ({ record }) => (
  <ul>
    {record.name}&nbsp;
    {record.approved ? <VerifiedIcon fontSize="small" color="#0e79f3" /> : <WarningIcon fontSize="small" color="error" />}
  </ul>
)

export const CustomerEdit = (props) => {
  const [disableInput, setDisableInput] = useState(false)
  const notify = useNotify();
  const handlePhoneChange = (event) => {

    HttpClient(SERVER + `/admin/customer/phone/` + event.target.value, {
      method: "GET",
    })
      .then(({ headers, json }) => {
        if (json.result) {
          setDisableInput(true)
          notify(` مشتری با این شماره وجود دارد  : ${json.result.name}`, { type: 'warning' });

        } else {
          setDisableInput(false)
        }
      })
      .catch((e) => {
      });


  }

  return (
    <Edit {...props}>
      <SimpleForm variant="outlined" redirect="list" disabled={disableInput} toolbar={!disableInput && <CreateFormActions />}>

        <NumberInput source="order" />

        <TextInput source="name" />
        <ReferenceInput source="customerCategoryId" reference="customerCategory">
          <SelectInput optionText="title" />
        </ReferenceInput>

        <BooleanInput source="approved" />
        <ArrayInput source="phoneNumbers">
          <SimpleFormIterator inline fullWidth={false}  >
            <TextInput source="number" helperText={false} onChange={handlePhoneChange} />
          </SimpleFormIterator>
        </ArrayInput>
        <Divider></Divider>
        <Divider></Divider>
        <Divider></Divider>

        <ReferenceArrayInput source="users" reference="adminUsers">
          {/* <SelectInput optionText="title" style={{ float: 'right', marginLeft: '10px', width: '70%' }} /> */}
          <AutocompleteArrayInput source="name" optionText="name" />
        </ReferenceArrayInput >


        {/* <SelectInput source='typeOfCustomer' choices={TypeOfCu} /> */}
        <ArrayInput source="connectors"/*   {...rest} */>

          <SimpleFormIterator>
            <ReferenceInput source="objectId"  filterToQuery={filterToQuery} reference="contact"/*  filter={{ typeOfCustomer: "HAGHIGHI" }}  */ >
              {/* <SelectInput optionText="title" style={{ float: 'right', marginLeft: '10px', width: '70%' }} /> */}
              <AutocompleteInput optionText="name" create={<CreateCustomerOrContactDialog title="ایجاد رابط" reso="contact" />} />
            </ReferenceInput>
          </SimpleFormIterator>

        </ArrayInput>
        {/* <CustomerCreateButton type="HOGHUGHI" /> */}
        <TextInput source="economicCode" variant='outlined' />
        <TextInput source="shenaseMeli" variant='outlined' />



        <ArrayInput source="companies" >

          <SimpleFormIterator>
            <ReferenceInput source="objectId" label="شرکت" reference="customer" filter={{ typeOfCustomer: "HOGHUGHI" }}>
              {/* <SelectInput optionText="title" style={{ float: 'right', marginLeft: '10px', width: '70%' }} /> */}
              <AutocompleteInput optionText="name" create={<CreateCustomerOrContactDialog title="ایجاد مشتری" reso="customer" />} />
            </ReferenceInput>
          </SimpleFormIterator>

        </ArrayInput>
        {/* <CustomerCreateButton type="HAGHIGHI" /> */}

        <TextInput source="meliCode" variant='outlined' />
        <TextInput source="description" multiline rows={5} />
        <TextInput source="tasvieCond" />

        <TextInput source="address" />
        <TextInput source="postalCode" />
        <TextInput source="email" />

        <ReferenceInput source="customerRatingId" reference="customerRating">
          <SelectInput optionText="title" />
        </ReferenceInput>

        <ReferenceInput source="contactPriorityId" reference="preferCall">
          <SelectInput optionText="title" />
        </ReferenceInput>
        <ReferenceInput source="customerPriorityId" reference="customerPriority">
          <SelectInput optionText="title" />
        </ReferenceInput>
      </SimpleForm>
    </Edit>
  )
};

export const CustomerShow = (props) => {


  const [tabIndex, setTabIndex] = useState(0);

  const [page, setPage] = useState(1);
  const { permissions } = usePermissions();

  const [filter, setFilter] = useState(false);

  const perPage = 1;
  const handleTabChange = (event, newTabIndex) => {
    setTabIndex(newTabIndex);
  };


  const { data, ids, total, error } = useGetList(
    'need',
    // {
    { page: 1, perPage: 15 },
    { field: 'updatedAt', order: 'DESC' },
    { isArchived: filter,customerId: props.id  },
    // }
  );
  const { data: reminderData, ids: reminderIds, total: totalReminder, loading: rLoading } = useGetList(

    'reminder',
    // {
    { page: 1, perPage: 15 },
    { field: 'updatedAt', order: 'DESC' },
    { company: props.id },
    // }
  );
  const { data: clueData, ids: clueIds, total: clueTotal} = useGetList(

    'clue',
    // {
    { page: 1, perPage: 15 },
    { field: 'updatedAt', order: 'DESC' },
    { company: props.id },
    // }
  );

  if (rLoading) {
    return <Loading />
  }
  if (error) {
    return <p>ERROR: {error}</p>
  }
  const filters = [<BooleanInput optionText="isArchived" alwaysOn label="پایان کار بیشتر از دو روز" source="isArchived" />];
  const filterValues = { isArchived: filter };
  const setFilters = filters => setFilter(filters.isArchived?true:false);

  return (
    <Show style={{ marginRight: "8px" }} {...props} variant="outlined" aside={<Aside sx={{ height: "40px" }} />} actions={null}>
      {/* <SimpleShowLayout> */}
      <div >
        <Box >
          <Box className="grid " >
            <Tabs variant="scrollable" allowScrollButtonsMobile 
            className="" value={tabIndex} onChange={handleTabChange}  >
              <Tab label="اطلاعات" />
              <Tab label="سرنخ‌ها"/>
              <Tab label="تمامی درخواست‌ها"/>
              <Tab label="یادآوری‌ها" />
              <Tab label="تراکنش‌ها"/>
            </Tabs>
          </Box>
          <Box sx={{ padding: 2 }} >
            {tabIndex === 0 && (
              <Box>
                <Grid container spacing={2} style={{ marginRight: "16px", marginLeft: "16px" }}>
                  <Grid item xs={6} style={{ fontSize: "20px", fontFamily: "IRANSansWeb" }}>
                    {(permissions?.includes(ROLES.ROOT) || permissions?.includes(ROLES.SUPER_ADMIN) || permissions?.includes(ROLES.MANAGER_CRM)) ?
                      <EditCustomerButton {...props} /> :
                      <TextField source="name" label="نام" style={{ fontSize: "20pt" }} />
                    }
                    <br />
                    <br /> <ArrayField source="phoneNumbers">
                      <SingleFieldList linkType={false}>
                        <ChipField source="number" helperText={false} variant="outlined" />
                      </SingleFieldList>
                    </ArrayField>
                    <br />
                    <br />

                    <div style={{ fontSize: "10pt", fontFamily: "IRANSansWeb", marginBottom: "16px" }}>
                      نقطه تماس
                    </div>
                    <ArrayField source="connectors" width="20%">
                      <SingleFieldList linkType="show">
                        <ReferenceField link="show" allowEmpty={true} label="" source="objectId" reference="contact">
                          <ApprovedChipField source="name" variant="outlined" />
                        </ReferenceField>
                      </SingleFieldList>
                    </ArrayField>
                    <br />

                  </Grid>
                  <Grid item xs={6} style={{ fontSize: "10pt", variant: "outlined" }}>

                    <br />
                    <ReferenceArrayField source="users" reference="adminUsers" >
                      <SingleFieldList linkType={false}>
                        <ChipField source="name" variant="outlined" />
                      </SingleFieldList>
                    </ReferenceArrayField>
                    <br />
                    اولویت تماس
                    <ReferenceField link={null} label="اولویت تماس" source="contactPriorityId" reference="preferCall" >
                      <ColoredChipField source="title" select="id" variant="outlined" />


                    </ReferenceField>

                    <br />
                    دسته مشتری <ReferenceField link={null} label="دسته مشتری" source="customerCategoryId" reference="customerCategory" >
                      <ChipField source="title" select="id" variant="outlined" />
                    </ReferenceField>
                    <br />
                    رتبه مشتری <ReferenceField link={null} source="customerRatingId" reference="customerRating" >
                      <ChipField source="title" select="id" variant="outlined" />
                    </ReferenceField>
                    <br />
                    اولویت‌بندی مشتری <ReferenceField link={null} source="customerPriorityId" reference="customerPriority" >
                      <ChipField source="title" select="id" defaultValue="" variant="outlined" />
                    </ReferenceField>
                  </Grid>
                </Grid>
              </Box>
            )}
            {tabIndex === 1 && (
              <Box>

                <CreateClueCustomerButton />
                <ListContextProvider actions={<ListActions />} value={{
                  data: keyBy(clueData, 'id'),
                  ids: clueIds,
                  total: clueTotal,
                  page,
                  perPage,
                  setPage,
                  currentSort: { field: 'id', order: 'ASC' },
                  basePath: "/clue",
                  resource: 'clue',
                  selectedIds: []
                }}>
                  <div>
                    <Title title="" />
                    {/* <FilterForm filters={filters} /> */}
                    <Card>
                      {/* <CreateButton basePath='/need' record={{"contactName": 'myValue'}} resource="need" size="large" /> */}
                      {/* <CreateButton redirect={(redirectTo, basePath, is, data) => `/need/create?source={"contactName":"ali "}`}
                resource="need"  /> */}
                      {isMobile ? (
                        <Datagrid rowClick="show">
                          {/* <TextField source="contactName" label="تماس گیرنده" />
          <ReferenceField link={null} label="وضعیت تماس" source="callResult" reference="statusCall" >
            <ColoredChipField source="title" select="id" />
          </ReferenceField> */}
                          <ArrayField source="order" label="سفارش">
                            <Datagrid>
                              <TextField label="تعداد" source="count" style={{ fontSize: "8pt" }} />
                              <ReferenceField link={null} label="نوع سفارش" source="productCRM" reference="orderType">
                                <TextField source="title" style={{ fontSize: "8pt" }} />
                              </ReferenceField>
                              <TextField label="تخفیف" source="discount" style={{ fontSize: "8pt" }} />
                            </Datagrid>
                          </ArrayField>
                        </Datagrid>
                      ) : (
                        <Datagrid rowClick="show">
                          <DateField label="زمان تماس" source="callTime" options={{ year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }} locales="fa-IR" />
                          {/* <TextField source="clueRefId" /> */}
                          <ChipField label="ایجاد کننده " source="ownerAdmin.name" select="id" />
                          <TextField source="contactName" label="تماس گیرنده" />

                          <ArrayField source="order" label="سفارش">
                            <Datagrid>
                              <TextField label="تعداد" source="count" style={{ fontSize: "8pt" }} />
                              <ReferenceField link={null} label="نوع بسته" source="typeOfBox" reference="package">
                                <TextField source="title" style={{ fontSize: "8pt" }} />
                              </ReferenceField>
                              <ReferenceField link={null} label="نوع سفارش" source="productCRM" reference="orderType">
                                <TextField source="title" style={{ fontSize: "8pt" }} />
                              </ReferenceField>
                              <TextField label="قیمت" source="price" style={{ fontSize: "8pt" }} />
                              <TextField label="تخفیف" source="discount" style={{ fontSize: "8pt" }} />
                            </Datagrid>
                          </ArrayField>
                          <ReferenceField link={null} label="وضعیت تماس" source="callResult" reference="statusCall" >
                            <ColoredChipField source="title" select="id" />
                          </ReferenceField>
                          <TextField source="title" label="عنوان " />
                        </Datagrid>
                      )}
                    </Card>
                  </div>
                </ListContextProvider>
              </Box>
            )}
            {tabIndex === 2 && (
              <Box>
                <CreateRelatedCustomerButton />
                <ListContextProvider actions={<ListActions />} value={{
                  data: keyBy(data, 'id'),
                  ids: ids,
                  total,
                  page,
                  perPage,
                  setPage,
                  filterValues, setFilters,
                  currentSort: { field: 'id', order: 'ASC' },
                  basePath: "/need",
                  resource: 'need',
                  selectedIds: []
                }}>
                  <div>
                    <Title title="Book list" />
                    {/* <FilterForm filters={filters} /> */}
                    <FilterForm filters={filters} />
                    <Card>
                      {/* <CreateButton basePath='/need' record={{"customerName": 'myValue'}} resource="need" size="large" /> */}
                      {/* <CreateButton redirect={(redirectTo, basePath, is, data) => `/need/create?source={"customerName":"ali "}`}
                resource="need"  /> */}
                      {isMobile ? (
                        <Datagrid rowClick={postRowClick} >
                          <ReferenceField link={null} label="نوع درخواست" source="needCategoryId" reference="needCategory" >
                            <TextField source="title" />
                          </ReferenceField>
                          <ReferenceField link={null} label="وضعیت  " source="statusId" reference="status" >
                            {/* <TextField source="title" style={postRowStyle}/> */}
                            <ColoredChipField source="title" select="id" />
                          </ReferenceField>
                          <NumberField source="refNum" label="کد پیگیری" locales="en" textAlign="left" />

                        </Datagrid>

                      ) : (

                        <Datagrid rowClick={postRowClick}>

                          <ReferenceField link={null} label="نوع درخواست" source="needCategoryId" reference="needCategory" >
                            <TextField source="title" />
                          </ReferenceField>
                          <ReferenceField link={null} label="واحد گیرنده " source="unitId" reference="unit" >
                            <TextField source="title" />
                          </ReferenceField>
                          <ReferenceField link={null} label="زیر واحد " source="unitProcessorId" reference="unitProcessor" >
                            <TextField source="title" />
                          </ReferenceField>
                          <TextField source="ownerName" label="درخواست کننده" />

                          <DateField source="updatedAt" options={{ year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }} locales="fa-IR" />
                          {/* {permissions?.includes(ROLES.SUPER_ADMIN) && <TextField source="customerName" />} */}


                          <NumberField source="refNum" locales="en" label="کد پیگیری" textAlign="left" />

                          <DateField source="dueDate" label="تاریخ تحویل" options={{ year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }} locales="fa-IR" />
                          <ReferenceField link={null} label="وضعیت  " source="statusId" reference="status" >
                            <ColoredChipField source="title" select="id" />
                          </ReferenceField>
                        </Datagrid>
                      )}
                    </Card>
                  </div>
                </ListContextProvider>
              </Box>
            )}
            {tabIndex === 3 && (
              <Box>

                <CreateAlarmCustomerButton />
                <ListContextProvider actions={<ListActions />} value={{
                  data: keyBy(reminderData, 'id'),
                  ids: reminderIds,
                  total: totalReminder,
                  page,
                  perPage,
                  setPage,
                  currentSort: { field: 'id', order: 'ASC' },
                  basePath: "/reminder",
                  resource: 'reminder',
                  selectedIds: []
                }}>
                  <div>
                    <Title title="Book list" />
                    {/* <FilterForm filters={filters} /> */}
                    <Card>
                      {/* <CreateButton basePath='/need' record={{"contactName": 'myValue'}} resource="need" size="large" /> */}
                      {/* <CreateButton redirect={(redirectTo, basePath, is, data) => `/need/create?source={"contactName":"ali "}`}
                resource="need"  /> */}
                      {isMobile ? (
                        <Datagrid rowClick="edit">
                          <TextField source="title" label="عنوان " />
                          <DateField label="زمان پیگیری" source="reminderTime" options={{ year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }} locales="fa-IR" />
                          <SelectField source="reminderPeriod" label="تکرار پیگیری" choices={choicesTime} />

                        </Datagrid>
                      ) : (

                        <Datagrid rowClick="edit" >

                          <ReferenceArrayField label="پیگیری کننده" source="users" reference="adminUsers">
                            <SingleFieldList linkType="show" >
                              <ChipField source="name" />
                            </SingleFieldList>
                          </ReferenceArrayField>


                          <DateField label="زمان پیگیری" source="reminderTime" options={{ year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }} locales="fa-IR" />
                          {/* <TextField source="description" label="یادداشت" /> */}

                          <SelectField source="reminderPeriod" label="تکرار پیگیری" choices={choicesTime} />
                          {/* source name ?*/}

                          <ReferenceField link={null} source="callType" label="نوع تماس" variant="outlined" reference="preferCall">
                            <ColoredChipField source="title" />
                          </ReferenceField>
                          <TextField source="title" label="عنوان " />

                        </Datagrid>
                      )}
                    </Card>
                  </div>
                </ListContextProvider>
              </Box>
            )}
            {tabIndex === 4 && (
              <Box>
                {/* <Button variant="contained" onClick={handleClickOpen}>{translate('resources.customer.fields.newTransaction')}</Button> */}
                <ReferenceManyField
                  fullWidth
                  empty={false}
                  label="Transactions"
                  reference="transaction"
                  target="customerId"
                  sort={{ field: 'date', order: 'DESC' }}
                  filter={{ "customerid": props.id }}
                >


                  <EditableDatagrid
                    undoable
                    noDelete
                    createForm={<TransactionForm initialValues={{ customerId: props.id }} />}
                    editForm={<TransactionForm />}
                    rowClick="edit"


                  >
                    <ReferenceField link="show" label='resources.transaction.fields.title' source="objectId" reference="transaction">
                      <TextField source="title" />
                    </ReferenceField>

                    <ReferenceField link="show" label="resources.transaction.fields.invoiceId" source="objectId" reference="transaction">
                      <TextField source="invoiceId" />
                    </ReferenceField>
                    <ReferenceField link="show" label="resources.transaction.fields.amount" source="objectId" reference="transaction">
                      <TextField source="amount" />
                    </ReferenceField>
                    <ReferenceField link="show" label="resources.transaction.fields.count" source="objectId" reference="transaction">
                      <TextField source="count" />
                    </ReferenceField>
                    <ReferenceField link="show" label="resources.transaction.fields.date" source="objectId" reference="transaction">
                      <DateField locales={"fa-IR"} source="date" />
                    </ReferenceField>

                  </EditableDatagrid>

                </ReferenceManyField>
                {/* <Dialog open={open} onClose={handleClose}>
                  <DialogTitle>ایجاد مخاطب</DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                    </DialogContentText>

                    <TextInput source="title" validate={required()} />
                    <TextInput source="invoiceId" validate={required()} />
                    <NumberInput source="amount" validate={required()} />
                    <NumberInput source="count" validate={required()} />
                    <DateInput locales={"fa-IR"} source="date" validate={required()} />
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleClose}>فعلا نه</Button>
                    <Button  >ایجاد تراکنش</Button>
                  </DialogActions>
                </Dialog> */}

              </Box>
            )}
          </Box>
        </Box>


      </div>
    </Show >
  )
};
const useFilterStyles = makeStyles({
  root: {
    "& .MuiFilledInput-root": {
      background: "rgb(250, 250, 250)"
    }
  }
  ,
});

const TransactionForm = (props) => {
  const classes = useFilterStyles();

  return (
    <RowForm  {...props}>
      <TextInput className={classes.root} source="title" validate={required()} />
      <TextInput className={classes.root} source="invoiceId" validate={required()} />
      <TextInput className={classes.root} onChange={handleNumberPersianChange} source="amount" validate={required()} />
      <TextInput className={classes.root} source="count" validate={required()} />
      <IdateInput className={classes.root} source='date' validate={required()} />
    </RowForm>
  )
};

const handleNumberPersianChange = (event) => {
  console.log(event)
}

const filterToQuery = searchText => ({ name: `${searchText}` });
export const CustomerCreate = (props) => {

  // const [contactData, setContactData] = useState({ contact: undefined })
  const [disableInput, setDisableInput] = useState(false)
  const [lastOrder, setLastOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  const notify = useNotify();

  useEffect(() => {
    if (loading) {

      HttpClient(SERVER + `/admin/customer/last`, {
        method: "GET",
      })
        .then(({ headers, json }) => {
          if (json.result) {
            setLastOrder(json.result.lastOrder)
            setLoading(false)
          }
        })
        .catch((e) => {
        });
    }
  })
  const handlePhoneChange = (event) => {

    HttpClient(SERVER + `/admin/customer/phone/` + event.target.value, {
      method: "GET",
    })
      .then(({ headers, json }) => {
        if (json.result) {
          // setContactData(json.result)
          setDisableInput(true)
          notify(` مشتری با این شماره وجود دارد  : ${json.result.name}`, { type: 'warning' });

        } else {
          setDisableInput(false)
        }
      })
      .catch((e) => {
      });


  }

  if (loading) {
    return <Loading />
  }

  return (
    <Create {...props} class="flex-column">
      <SimpleForm variant="outlined" redirect="list" disabled={disableInput} toolbar={!disableInput && <CreateFormActions />}>
        <NumberInput source="order" defaultValue={lastOrder} />

        <TextInput source="name" />
        <ReferenceInput source="customerCategoryId" label="دسته مشتری" reference="customerCategory">
          <SelectInput optionText="title" />
        </ReferenceInput>

        <ArrayInput source="phoneNumbers">
          <SimpleFormIterator inline fullWidth={false}  >
            <TextInput source="number" helperText={false} onChange={handlePhoneChange} />
          </SimpleFormIterator>
        </ArrayInput>
        <Divider></Divider>
        <Divider></Divider>
        <Divider></Divider>

        <ReferenceArrayInput source="users" label="همکاران" reference="adminUsers">
          {/* <SelectInput optionText="title" style={{ float: 'right', marginLeft: '10px', width: '70%' }} /> */}
          <AutocompleteArrayInput source="name" optionText="name" />
        </ReferenceArrayInput >


        <ArrayInput source="connectors">

          <SimpleFormIterator>
            <ReferenceInput source="objectId"  reference="contact" filterToQuery={filterToQuery} >
              {/* <SelectInput optionText="title" style={{ float: 'right', marginLeft: '10px', width: '70%' }} /> */}
              <AutocompleteInput   create={<CreateCustomerOrContactDialog title="ایجاد رابط" reso="contact" />} />
            </ReferenceInput>
          </SimpleFormIterator>

        </ArrayInput>
        {/* <CustomerCreateButton type="HOGHUGHI" /> */}
        <TextInput source="economicCode" label="کد اقتصادی" variant='outlined' />
        <TextInput source="shenaseMeli" label="شناسه ملی" variant='outlined' />



        <ArrayInput source="companies" >

          <SimpleFormIterator>
            <ReferenceInput source="objectId" label="شرکت" reference="customer" filter={{ typeOfCustomer: "HOGHUGHI" }}>
              {/* <SelectInput optionText="title" style={{ float: 'right', marginLeft: '10px', width: '70%' }} /> */}
              <AutocompleteInput optionText="name" create={<CreateCustomerOrContactDialog title="ایجاد مشتری" reso="customer" />} />
            </ReferenceInput>
          </SimpleFormIterator>

        </ArrayInput>
        {/* <CustomerCreateButton type="HAGHIGHI" /> */}

        <TextInput source="meliCode" label="کد ملی" variant='outlined' />
        <TextInput source="description" multiline rows={5} />
        <TextInput source="tasvieCond" />

        <TextInput source="address" />

        <TextInput source="postalCode" />
        <TextInput source="email" />
        <ReferenceInput source="customerRatingId" label="رتبه مشتری" reference="customerRating">
          <SelectInput optionText="title" />
        </ReferenceInput>

        <ReferenceInput source="contactPriorityId" label="اولویت تماس" reference="preferCall">
          <SelectInput optionText="title" />
        </ReferenceInput>
        <ReferenceInput source="customerPriorityId" label="اولویت‌بندی مشتری" reference="customerPriority">
          <SelectInput optionText="title" />
        </ReferenceInput>
      </SimpleForm>
    </Create >
  )
};
const ListActions = (props) => (
  <TopToolbar>
    <CreateButton />
  </TopToolbar>
);


const CreateRelatedCustomerButton = () => {
  const record = useRecordContext();
  return (
    <Button
      startIcon={<Add />}
      color="primary" variant="outlined"
      style={{ margin: "20px" }}
      component={Link}
      to={{
        pathname: '/need/create',
        state: { record: { customerId: record.id, customerRefNum: record.id } },
      }}
    >
      ایجاد درخواست
    </Button>
  )
};

const CreateClueCustomerButton = () => {
  const record = useRecordContext();

  return (
    <Button
      startIcon={<Add />}
      color="primary" variant="outlined"
      component={Link}
      style={{ margin: "20px" }}

      to={{
        pathname: '/clue/create',
        state: {
          record: {
            companyName: record.name,
            users: record.users,
            company: record.id, phoneNumber: record.phoneNumbers[0]?.number
          }
        },
      }}
    >      ایجاد سرنخ
    </Button>
  )
};
const CreateAlarmCustomerButton = () => {
  const record = useRecordContext();

  return (
    <Button
      startIcon={<Add />}
      color="primary" variant="outlined"
      component={Link}
      style={{ margin: "20px" }}

      to={{
        pathname: '/reminder/create',
        state: {
          record: {
            company: record.id,
            users: record.users,
            customerRefNum: record.id
          }
        },
      }}
    >
      ایجاد یادآوری
    </Button>
  )
};
const EditCustomerButton = (props) => {
  const record = useRecordContext();

  return (
    <Button
      // startIcon={<Add />}
      color="secondary" variant="outlined"
      style={{ fontSize: "140pt" }}
      component={Link}
      fontSize="20pt"
      to={{
        pathname: '/customer/' + record.id,
      }}
    >
      <Typography color="black" style={{ fontSize: "20pt", fontFamily: "IRANSansWeb" }}>
        {record.approved ? <VerifiedIcon fontSize="20pt" color="#0e79f3" /> : <WarningIcon fontSize="20pt" color="error" />}
        {record.name}

      </Typography>
    </Button>
  )
};
export const CreateCustomerOrContactDialog = (props) => {
  const { filter, onCancel, onCreate } = useCreateSuggestionContext();
  const [value, setValue] = React.useState(filter || '');
  const [phoneNumber, setPhoneNumber] = React.useState({ number: '' });

  const [create] = useCreate();

  const handleSubmit = event => {
    event.preventDefault();
    create(
      // 'customer',
      props.reso,
      {
        name: value,
        phoneNumbers: [phoneNumber]
        //add phoneNumber
        // typeOfCustomer: props.type
      },
      {
        onSuccess: ({ data }) => {
          setValue('');
          onCreate(data);
        },
      }
    );
  };

  return (
    <Dialog open onClose={onCancel}>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <TextFieldMui
            variant="filled"
            label={props.title}
            value={value}
            onChange={event => setValue(event.target.value)}
            autoFocus
          /><br />
          <TextFieldMui
            variant="filled"
            label="تلفن"
            // value={phoneNumber}
            onChange={event => setPhoneNumber({ number: event.target.value })}
          />
        </DialogContent>
        <DialogActions>
          <Button type="submit"> {props.title}</Button>
          <Button onClick={onCancel}>فعلا نه</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};


const Aside = (props) => {
  const { isLandscape } = useMobileOrientation()
  const isKeyboardOpen = useDetectKeyboardOpen();

  return (
    <div style={{ margin: '1em', overflow: 'auto', height: "700px", borderTopWidth: "3px", borderBottomWidth: "3px" }}>
      {((isMobile && isLandscape && !isKeyboardOpen) || !isMobile) ? (

        <Box sx={{ width: '100%', height: "40px", }}>
          <Typography variant="h6">نظرات</Typography>
          <CustomerCreateCommentButton customer={props.record} />
          <Stepper orientation="vertical" >
            {


              (props.record && props.record.comments) ? props.record.comments.map((his, i) => (


                <Step expanded active completed >
                  <StepLabel>
                    <div>

                      {new Date(his.createdAt).toLocaleString("fa", { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', })}
                    </div>
                    <div>
                      تغییر توسط :
                      {his.commentBy?.name}
                    </div>
                    {(his.content) ? (
                      <div>

                        <div>
                          کامنت  :

                        </div>
                        <div><p style={{ "white-space": "pre-wrap", "overflow-wrap": "break-word", "inline-size": "250px" }}>{his.content}</p></div>
                      </div>

                    ) : null}
                    <Divider></Divider>

                  </StepLabel>
                  <StepContent>
                    <RecordContextProvider value="تغییر داده شده">
                    </RecordContextProvider>
                  </StepContent>
                </Step>
              )) : null
            }
          </Stepper>
        </Box>
      ) : (
        <Box></Box>
      )}
    </div>
  )
}



// CreateHoghughi